<template>
	<section class="fullcontainer" v-if="getCampanha">

	<div class="calendar-container">
		<div class="calendar-header">
			<p> {{ currentYear }} </p>
			<div style="text-align: end; margin-right: 5px">
			<select v-model="selectedMonth">
				<option v-for="(month, index) in months" :key="index" :value="index"> {{ month }}</option>
			</select>
			</div>
		</div>

		<div class="calendar">
			<span class="day-name">Domingo</span>
			<span class="day-name">Segunda</span>
			<span class="day-name">Terça</span>
			<span class="day-name">Quarta</span>
			<span class="day-name">Quinta</span>
			<span class="day-name">Sexta</span>
			<span class="day-name">Sabado</span>

			<div class="day" v-for="(day,index) in domCalendar" :key="index" @click="dayDetails(day.num, selectedMonth, currentYear, day.disabled, day.num)" :class="{'day--disabled': day.disabled, 'grid-day': !day.disabled, 'highlight': selectedGrid == day.num && !day.disabled && tmp_date.month == selectedMonth}">

				<section :class="{'currentDay': day.currentDay}"> {{ day.num }} </section>
				<section v-if="!day.disabled"  class="day-call-info">
					<!-- <template v-if="day.calls.length > 0">  <i class="fas fa-phone verde"></i>  {{ day.calls[0].calls}} </template>
					<template v-if="day.reminders.length > 0"> <i class="fas fa-sticky-note stick-agendamento"></i>  {{ day.reminders[0].reminders}} </template> -->
					<template v-if="day.client_name.length > 0">
						<div class="day-text" v-for="(el,index) in Object.entries(day.client_name[0])" :key="index">{{`${el[0]} - ${el[1]}`}}</div>
					</template>
				</section>

			</div>


		</div>

	</div>

	<div class="tmp-calendar-container">
		<div class="tmp-calendar-header">

			<strong> {{ tmp_date.day}}/{{ tmp_date.month + 1}}/{{ tmp_date.year }} </strong>
		</div>

		<div class="tmp-calendar-day">
			<div class="tmp-hour"  v-for="(day, index) in arrNum" :key="index">
				<p>  <strong>{{ day.hora }}</strong>h  </p>
				<section  class="tmp-agendamento">
					<template v-if="day.details.length > 0">

						<button v-for="(info, index) in day.details"
							:key="index"
							:class="['button-show-schedule', 'green', {'stick-color': !info.phone_one}]"
							 @click="showSchedule(info)">

						  <template v-if="info.phone_one">
							<i class="fas fa-phone verde"></i>
						  </template>
						  <template  v-else>
							<i class="fas fa-sticky-note stick-agendamento"></i>
						  </template>
						  {{ info.client_name}}

						</button>
					</template>
				</section>
				<section class="tmp-create-new-schedule" @click="createNewSchedule(day.hora)">
					<i class="fas fa-plus-circle"></i>
				</section>
			</div>
		</div>
	</div>

	</section>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';

export default{
	data(){
		return {
			selectedGrid: undefined,
			today: new Date(),
			tmp_date: {
				day: new Date().getDate(),
				month: new Date().getMonth(),
				year: new Date().getFullYear()


			},
			domCalendar:[],
			isActive: false,
			selectedMonth: new Date().getMonth(),
			currentYear: new Date().getFullYear(),
			months:[
				'Janeiro',
				'Fevereiro',
				'Março',
				'Abril',
				'Maio',
				'Junho',
				'Julho',
				'Agosto',
				'Setembro',
				'Outubro',
				'Novembro',
				'Dezembro'
			],
			arrNum: [
				{hora: 0, details: []},
				{hora: 1, details: []},
				{hora: 2, details: []},
				{hora: 3, details: []},
				{hora: 4, details: []},
				{hora: 5, details: []},
				{hora: 6, details: []},
				{hora: 7, details: []},
				{hora: 8, details: []},
				{hora: 9, details: []},
				{hora: 10, details: []},
				{hora: 11, details: []},
				{hora: 12, details: []},
				{hora: 13, details: []},
				{hora: 14, details: []},
				{hora: 15, details: []},
				{hora: 16, details: []},
				{hora: 17, details: []},
				{hora: 18, details: []},
				{hora: 19, details: []},
				{hora: 20, details: []},
				{hora: 21, details: []},
				{hora: 22, details: []},
				{hora: 23, details: []}
			],
		}
	},
	watch:{
		selectedMonth: function(){
			this.updateCalendar();
		},
		remoteUpdateCalendar: function(){

			this.updateCalendar();
			this.tmp_updateDayDetails();
		}
	},
	computed:{
		...mapGetters([
			'getCampanha',
			'getModalSchedule',
			'remoteUpdateCalendar'
		])
        },
	methods:{
		...mapActions(['setModalSchedule', 'setClientToModal', 'storeHour']),
		showSchedule(info){
			this.setModalSchedule();
			this.setClientToModal(info);
		},
		createNewSchedule(hora){

			hora = `${hora}`;
			let mes = `${this.tmp_date.month + 1}`;
			let dia = `${this.tmp_date.day}`

			this.storeHour(`${this.tmp_date.year}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')} ${hora.padStart(2, '0')}:00:00`);
			this.setModalSchedule();
		},
		dayDetails: function(day, month, year, disabled, num){
			if(disabled) return;
			this.tmp_date.day = day;
			this.tmp_date.month = month;
			this.tmp_date.year = year;

			this.selectedGrid = num;

			this.tmp_updateDayDetails();
		},
		daysInMonth: (month, year) => {
			return new Date(year, month + 1, 0).getDate();
		},
		dayOfWeek: (month, year, day) => {
			return new Date(year, month, day).getDay() ;
		},
		tmp_updateDayDetails(){

			let day = `${this.tmp_date.day}`;
			let month = `${this.tmp_date.month + 1}`;
			let year = this.tmp_date.year;

			let dia = day.padStart(2, '0');
			let mes =  month.padStart(2, '0');

			this.arrNum.map( el => el.details.splice(0, el.details.length));

			fetch(`calendar-details?date=${year}-${mes}-${dia}`)
  				.then(response => response.json())
  				.then(data => {

					if(!data) return;

					data.map(el => {
						let match = el.start_date.match(/\s\d{2}/);
						let hora = undefined;
						if(match)
							hora = match[0].trim();

						this.arrNum[parseInt(hora)].details.push(el);
					})

  				})
  			.catch(error => console.error(error));
		},
		updateCalendar(){
			let calendar = [];

			// Quantidade de dias, ultimo dia do mes e primeiro dia do mes
			let first_day_week = this.dayOfWeek(this.selectedMonth, this.currentYear,1);
			let last_day = this.daysInMonth(this.selectedMonth, this.currentYear);
			let last_day_week = this.dayOfWeek(this.selectedMonth, this.currentYear, last_day);

			let last_day_previous_month = 32;
			// pegar ultimo dia do mes anterior
			if(first_day_week != 0) {


				if(this.selectedMonth == 0){
					last_day_previous_month = this.daysInMonth(11, this.currentYear - 1) + 1;

				}else{
					last_day_previous_month = this.daysInMonth(this.selectedMonth - 1, this.currentYear) + 1;
				}

			}

			// Pad mes anterior
			for(var i=0; i < first_day_week; i++){
				let day = (last_day_previous_month - first_day_week) + i;
				calendar.push({num: day, disabled: true, currentDay:false});
			}

			// insere dias do mes
			for(var i=1; i <= last_day; i++){
				var currentDay = false;
				if(this.today.getFullYear() == this.currentYear && this.today.getMonth() == this.selectedMonth && this.today.getDate() == i){
					currentDay = true;
				}
				calendar.push({num: i, disabled: false, currentDay: currentDay, calls:[], reminders:[], client_name:[]});
			}

			let next_month_days = 1;
			for(var i=last_day_week; i< 6; i++){
				calendar.push({num:next_month_days, disabled: true, currentDay: false});
				next_month_days++;
			}

			this.domCalendar = calendar

			let mes = `${this.selectedMonth  + 1}`;
			mes = mes.padStart(2, '0');
			fetch(`calendar?month=${this.currentYear}-${mes}`)
  				.then(response => response.json())
  				.then(data => {
					if(!data) return;

					this.domCalendar.map((el,index) => {
						if(el.disabled) return;

						let found =  data.find( regis => regis.day  ==  el.num);

						if(!found) return;

						if(found.calls)
							this.domCalendar[index].calls.push(found);

						if(found.reminders)
							this.domCalendar[index].reminders.push(found);

						if(found) {
							delete found.day
							delete found.calls
							delete found.reminders
							this.domCalendar[index].client_name.push(found);
						}
					});
  				})
  			.catch(error => console.error(error));
		}
	},
	created(){
		this.updateCalendar();
		this.tmp_updateDayDetails();
		setInterval(this.updateCalendar(),300000)
	}


}

</script>

<style scoped>

.calendar-container {
    width: auto;
    overflow: auto;
    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    background: #fff;
    max-width: 1200px;
    min-width: calc(74% - 1.5em);
    margin-top: 1em;
    margin-left: 1em;
}

.calendar-header {
	text-align: center;
    border-bottom: 3px solid #f38630;
    line-height: 4em;
    background-color: #1c869a;
}

.calendar-header select {
	text-align: center;
	border-radius: 10px;
	font-size: 16px;
	cursor: pointer;
}
.calendar-header h1 {
    margin: 0;
    font-size: 18px;
}

.calendar-header button {
    background: 0;
    border: 0;
    padding: 0;
    color: rgba(81, 86, 93, 0.7);
    cursor: pointer;
    outline: 0;
}

.calendar {
    display: grid;
    width: 100%;
    /* grid-template-columns: repeat(7, minmax(120px, 1fr)); */
    grid-template-rows: 50px;
    grid-auto-rows: 120px;
    overflow: auto;
}
.calendar-header p {
    margin: 5px 0 0 0;
    font-size: 22px;
    font-weight: 700;
	color: white;
}
.day-name {
    font-size: 12px;
    text-transform: uppercase;
    color: #99a1a7;
    text-align: center;
    border-bottom: 1px solid rgba(166, 168, 179, 0.12);
    line-height: 50px;
    font-weight: 500;
}
.day-text {
    color: darkorange;
    text-align: start;
    font-weight: 700;
}

.day {
    border-bottom: 1px solid rgba(166, 168, 179, 0.12);
    border-right: 1px solid rgba(166, 168, 179, 0.12);
    text-align: right;
    padding: 14px 20px;
    letter-spacing: 1px;
    font-size: 12px;
    box-sizing: border-box;
    color: #98a0a6;
    position: relative;
    z-index: 1;
}

.day--disabled {
	color: rgba(152, 160, 166, 0.6);
	background-color: #ffffff;
	background-image: url("/imgs/icons/disable.svg");
	cursor: not-allowed;
}
.day button{
    text-align: initial;
    float: left;
    border: none;
    border-radius: 0.25em !important;
    padding: 0.25em;
    min-width: 9.25em;
    max-width: 9.25em;
    background-color: #1c869a;
    color: white;
    margin-top: 0.25em;
    padding-left: 0.5em;
    max-height: 2em;
}
.day button i {
    border-right: solid 1px;
    padding-right: 0.5em;
}
.day-call-info{
	float:left;
}
.day-call-info i {
    border-right: solid 1px;
    padding-right: 0.5em;
}

.stick-agendamento{
	color:orange;
}

.verde{
    color:green;
}

.day p{
    position: absolute;
    float: right;
    border: solid;
    border-radius: 50%;
    margin: 0;
    width: 16%;
    margin-left: 10em;
    text-align: center;
    border: none;
    height: 20%;
    padding-top: 3px;

}
.currentDay{
    color: white;
	background-color: #ff8f94;
	border-radius: 50%;
	padding: 1px 5px;
    float: right;
}
.grid-day{
	cursor:pointer;
}
.grid-day:hover{
	background-color:rgba(125,125,125,0.2);
	color: #202020;
	transition: 0.2s;
}
.task {
    border-left-width: 3px;
    padding: 8px 12px;
    margin: 10px;
    border-left-style: solid;
    font-size: 14px;
    position: relative;
}
.task--danger {
    border-left-color: #fa607e;
    grid-column: 2/span 3;
    grid-row: 3;
    margin-top: 15px;
    background: rgba(253, 197, 208, 0.7);
    align-self: end;
    color: #f8254e;
}

.task--info {
    border-left-color: #4786ff;
    grid-column: 6/span 2;
    grid-row: 5;
    margin-top: 15px;
    background: rgba(218, 231, 255, 0.7);
    align-self: end;
    color: #0a5eff;
}

.task--primary {
    background: #4786ff;
    border: 0;
    border-radius: 4px;
    grid-column: 3/span 3;
    grid-row: 4;
    align-self: end;
    color: #fff;
    box-shadow: 0 10px 14px rgba(71, 134, 255, 0.4);
}


.task__detail {
    position: absolute;
    display:none;
    left: 0;
    top: calc(100% + 10px);
    background: #fff;
    border: 1px solid rgba(166, 168, 179, 0.2);
    color: #000;
    padding: 20px;
    box-sizing: border-box;
    border-radius: 4px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
    z-index: 2;
}
.task--warning {
	border-left-color: #fdb44d;
	grid-column: 4/span 3;
	grid-row: 3;
	background: #fef0db;
	align-self: center;
	color: #fc9b10;
	margin-top: -5px;
}
.show{
	display:block;
}

.day:nth-of-type(7n + 7) {
    border-right: 0;
  }

  .day:nth-of-type(n + 1):nth-of-type(-n + 7) {
    grid-row: 2;
  }

  .day:nth-of-type(n + 8):nth-of-type(-n + 14) {
    grid-row: 3;
  }

  .day:nth-of-type(n + 15):nth-of-type(-n + 21) {
    grid-row: 4;
  }

  .day:nth-of-type(n + 22):nth-of-type(-n + 28) {
    grid-row: 5;
  }

  .day:nth-of-type(n + 29):nth-of-type(-n + 35) {
    grid-row: 6;
  }

  .day:nth-of-type(7n + 1) {
    grid-column: 1/1;
  }

  .day:nth-of-type(7n + 2) {
    grid-column: 2/2;
  }

  .day:nth-of-type(7n + 3) {
    grid-column: 3/3;
  }

  .day:nth-of-type(7n + 4) {
    grid-column: 4/4;
  }

  .day:nth-of-type(7n + 5) {
    grid-column: 5/5;
  }

  .day:nth-of-type(7n + 6) {
    grid-column: 6/6;
  }
  .day:nth-of-type(7n + 7) {
    grid-column: 7/7;
  }

.tmp-calendar-container{
    width: auto;
    overflow: hidden;
    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    background: #fff;
    margin-top: 1em;
    margin-left: 1em;
    min-width:23%;
}

.tmp-calendar-header{
    text-align: center;
    padding: 20px 0;
    background: linear-gradient(to bottom, #fafbfd 0%, rgba(255, 255, 255, 0) 100%);
    border-bottom: 1px solid rgba(166, 168, 179, 0.12);
    color: rgba(81, 86, 93, 0.4);
    font-size: 1.5em;
}
.tmp-calendar-day{
	height:100%;
	overflow:auto;
    padding-bottom: 15%;
}

.tmp-calendar-day p{
	font-size: 2em;
	color: rgba(81, 86, 93, 0.4);
}

.tmp-calendar-day p {
	font-size:1em;
}
.tmp-calendar-day p strong{
	font-size: 1.25em;
}
.tmp-calendar-day p:last-child{
	margin-bottom: 10px;
}
.tmp-hour:hover{
	background-color:rgba(125,125,125,0.2);
}
.tmp-hour{
    display:flex;
    border: solid 1px lightgray;
    color: rgba(81, 86, 93, 0.4);
    justify-content: space-between;

}

.tmp-hour:last-child {
	margin-bottom: 25px;
}

.tmp-agendamento{
	display: flex;
	flex-wrap:wrap;
}

.fullcontainer{
	display:flex;
	height:100%;

	height: calc(100vh - 12.5em);
	display: flex;
	align-items: stretch;
}
.highlight{
	background-color: lightgray;
	color: #202020;
	font-weight: 600;
}
.tmp-create-new-schedule{
	cursor:pointer;
}

.tmp-create-new-schedule i{
    font-size: 1.4em;
    margin-top: 0.6em;
    margin-right: 0.4em;
}

.tmp-create-new-schedule:hover > i{
	color:#24a4bd;
	transition: 0.6s;
}

.button-show-schedule{
	border-radius: 0.25em !important;
	border: none;
	margin-top: 0.2em;
	margin-bottom: 0.2em;
	margin-right: 0.5em;
	background: none;
}

@media(max-width: 1040px) {
	.day-name {
		font-size: 9px;
	}
  }

  @media(max-width: 941px) {
	.calendar-container {
		width: 92%;
	}
  }
</style>
